import React, { useEffect, useState} from 'react'
import styles from './CompanyFormsPage.module.css'
import axios from "axios";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {
    Alert,
    Grid, MenuItem,
    Select,
    SelectChangeEvent
} from "@mui/material";
import {DataGridPremium, GridRowParams, MuiEvent} from "@mui/x-data-grid-premium";
import {GridCallbackDetails, GridColDef, GridToolbarContainer} from "@mui/x-data-grid-pro";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import FindWorkOrder from "./FindWorkOrder";
import PdfViewerComponent from "../../../components/PdfViewerComponent";
import BaseFileName from "./BaseFileName";
import {getConfig} from "../../../AppConfig";
const { secretkey } = getConfig()

const CompanyFormsPage = (params) => {
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [findWorkOrder, setFindWorkOrder] = React.useState(false)
    const [findBaseFilename, setFindBaseFilename] = React.useState(false)
    const [findBaseFilenameString, setFindBaseFilenameString] = React.useState('')
    const [openViewer, setOpenViewer] = React.useState(false)
    const [woid, setWoid] = React.useState<number>(0)
    const [data, setData] = useState([])
    const [dataFiltered, setDataFiltered] = useState([])
    const [activeCategory, setActiveCategory] = React.useState( 'All');
    const [dialogMsg, setDialogMsg] = React.useState( '');
    // const [watchLogoData, setWatchLogoData] = React.useState(null)
    const [watchLogoDataURL, setWatchLogoDataURL] = React.useState(null)
    const [rowData, setRowData] = React.useState( {generalformsid: null, generalformsgoogledriveid: '', generalformscategory: "", generalformstiedtowo: false, generalformsname: "", generalformsnamebase: "", generalformsreadonly: false, generalformsallowchangefilename: false, generalformsfilename: ""});

    useEffect(() => {
        params.setTitle('General Forms')
        getData()
    }, [])

    useEffect(() => {
        if (woid > 0 || findBaseFilenameString?.length > 0) {
            getDocumentFile(rowData)
        }
    }, [woid, findBaseFilenameString])

    const getData = () => {
        setLoadingBackdrop(true)
        axios.get(`fieldsystemcompanyforms`).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            const formdata = dataJson?.formlist?.map((item) => {
                return {...item, id: item.generalformsid}
            })

            setData(formdata)
            setDataFiltered(formdata)
            debugger
            setLoadingBackdrop(false)
        }).catch(error => {
            if (error.response) {
                setDialogMsg(error?.response?.data?.title)
            } else if (error.request) {
                setDialogMsg(error.request)
            } else {
                setDialogMsg(error.message)
            }
            setLoadingBackdrop(false)
        })
    }

    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    const getCategoryOptions = () => {
        const dist = data.filter((obj, index, self) =>
            index === self.findIndex((t) => t.generalformscategory === obj.generalformscategory)
        );

        const menuItemsToAdd = dist?.map(item => (
            <MenuItem key={item.generalformscategory} value={item.generalformscategory}>
                {item.generalformscategory}
            </MenuItem>
        ))
        return [
            (
                <MenuItem key={'All'} value={"All"}>
                    {'All'}
                </MenuItem>),
            ...menuItemsToAdd
        ]
    }

    const handleCategoryChange = (event: SelectChangeEvent) => {
        setActiveCategory(event.target.value)
        if (event.target.value === 'All') {
            setDataFiltered(data)
        }
        else {
            setDataFiltered(data?.filter((item) => item.generalformscategory === event.target.value ))
        }
    }

    const getDocumentFile = (gererealformsdata) => {
        var filename = rowData?.generalformsname + ' - ' + rowData?.generalformsfilename
        if (findBaseFilenameString && findBaseFilenameString?.length > 0) {
            filename = findBaseFilenameString
        }
        debugger
        
        // Check if file is a spreadsheet
        const extension = rowData?.generalformsfilename?.split('.').pop()?.toLowerCase();
        const isSpreadsheet = ['xls', 'xlsx', 'csv'].includes(extension);

        var urlTOOpen = isSpreadsheet ? '/filesystem/spreadsheet/' : '/filesystem/pdfpage/'
        urlTOOpen += rowData?.generalformsgoogledriveid + '/' + woid

        var CryptoJS = require("crypto-js");
        var encriptedString = CryptoJS.AES.encrypt(JSON.stringify({
            driveid: rowData?.generalformsgoogledriveid,
            woid: woid,
            generalformsid: rowData.generalformsid,
            filename: filename,
            save: !rowData?.generalformsreadonly,
            readonly: rowData?.generalformsreadonly,
        }), secretkey).toString();

        if (rowData?.generalformsgoogledriveid && rowData?.generalformsgoogledriveid?.length > 0) {
            // urlTOOpen += '/' + encodeURIComponent(encriptedString)
            localStorage.setItem('pdfopen-' + rowData?.generalformsgoogledriveid + '-' + woid, encriptedString)
        }
        window.open(urlTOOpen)
    }

    useEffect(()=> {
        if (rowData?.generalformsid > 0) {
            if (rowData?.generalformstiedtowo) {
                setFindWorkOrder(true)
            }
            else if (!rowData?.generalformsreadonly && rowData?.generalformsallowchangefilename) {
                setFindBaseFilename(true)
            }
            else {
                getDocumentFile(rowData)
            }
        }
    }, [rowData])


    const handleRowClick = (param : GridRowParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        const newRowData = {...param?.row}
        debugger
        setRowData(newRowData)
    }
    function CustomGridToolbar() {
        return (
            <GridToolbarContainer >
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-begin"
                    alignItems="center"
                >
                    <Grid item xs={4} padding={0} spacing={0}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-begin"
                            alignItems="center"
                        >
                            <Grid item xs={12} padding={0} spacing={0}>
                                <Select
                                    onChange={handleCategoryChange}
                                    style={{ width: '100%', height:'30px' }}
                                    value={activeCategory}
                                >
                                    {getCategoryOptions()}
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </GridToolbarContainer>
        )
    }

    const saveDocumentCallback = (documentItem) => {
        setLoadingBackdrop(true)

        const formData = new FormData();
        formData.append('file', documentItem.blob, 'document.pdf');
        formData.append('GUID', '');
        formData.append('IsSaveAsBuilt', documentItem.issaveasbuilt ?? false);
        formData.append('mimetype', 'none');

        if (documentItem?.woid > 0) {
            formData.append('woid', documentItem?.woid)
        }
        if (documentItem?.filename?.length > 0) {
            formData.append('filename', documentItem?.filename)
        }
        if (documentItem?.generalformsgoogledriveid && documentItem?.generalformsgoogledriveid?.length > 0) {
            formData.append('id', documentItem?.generalformsgoogledriveid)
        }
        if (documentItem?.generalformsid > 0) {
            formData.append('generalformsid', documentItem?.generalformsid)
        }

        axios.put(`api/documentsbloboverwrite`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then((response) => {
            const data = JSON.parse(response.data.jsonString)
            documentItem.setLoadingBackdrop(false)
            setLoadingBackdrop(false)
            if (data.status == 'failure') {
                setDialogMsg(data.message)
            }
            else if (data.status == "success") {
                setOpenViewer(false)
                setDialogMsg(data?.message?.length > 0 ? data.message : "Successfully Saved")
            }
        }).catch(error => {
            if (error.response) {
                setDialogMsg(error?.response?.data?.title)
            } else if (error.request) {
                setDialogMsg(error.request)
            } else {
                setDialogMsg(error.message)
            }
            documentItem.setLoadingBackdrop(false)
            setLoadingBackdrop(false)
        })
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    const columns: GridColDef[] = [
        {
            field: 'generalformsname',
            type: 'string',
            headerName: 'Form Name',
            width: 320
        },
        {
            field: 'generalformscategory',
            type: 'string',
            headerName: 'Category',
            width: 260,
            align: 'left',
            headerAlign: 'left',
        },
        {
            field: 'generalformstiedtowo',
            type: 'boolean',
            headerName: 'Requires Work Order',
            align: 'center',
            headerAlign: 'left',
            width: 170,
        },
    ]


    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />

            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <Dialog
                    open={openViewer}
                    fullWidth={true}
                    maxWidth="xl"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <div className="PDF-viewer">
                            <PdfViewerComponent
                                save={true}
                                item={{allowsave: true}}
                                woid={woid}
                                readonly={rowData.generalformsreadonly}
                                filename={findBaseFilenameString}
                                generalformsgoogledriveid={rowData.generalformsgoogledriveid}
                                generalformsid={rowData.generalformsid}
                                saveDocumentCallback={saveDocumentCallback}
                                // saveDocument={saveDocument}
                                document={watchLogoDataURL}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setOpenViewer(false)
                            setWatchLogoDataURL(null)
                        }}>Close</Button>
                        {/*<Button>Save</Button>*/}
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <FindWorkOrder setFindWorkOrder={setFindWorkOrder} findWorkOrder={findWorkOrder} setFindBaseFilenameString={setFindBaseFilenameString} setWoid={setWoid} woid={woid} generalformstiedtowo={rowData.generalformstiedtowo} generalformsnamebase={rowData.generalformsnamebase} generalformsreadonly={rowData.generalformsreadonly} generalformsallowchangefilename={rowData.generalformsallowchangefilename} />
                    <BaseFileName setFindBaseFilename={setFindBaseFilename} findBaseFilename={findBaseFilename} setFindBaseFilenameString={setFindBaseFilenameString} generalformsnamebase={rowData.generalformsnamebase} generalformsreadonly={rowData.generalformsreadonly} generalformsallowchangefilename={rowData.generalformsallowchangefilename} />
                    <Grid
                        container
                        border={0}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        height={'100%'}
                        width={'100%'}
                    >
                        <>
                            <Grid item border={0} marginRight={1} md={12} xs={12}>
                                {/*<div style={{marginBottom: '50', justifyContent: 'center', alignItems: 'center', alignContent:'center'}} >Add vacation days.</div>*/}
                                <DataGridPremium
                                    rows={dataFiltered}
                                    columns={columns}
                                    autoHeight={true}
                                    density={'compact'}
                                    pageSize={10}
                                    loading={false}
                                    disableMultipleSelection={true}
                                    // onRowClick={handleRowClick}
                                    onRowDoubleClick={handleRowClick}
                                    components={{
                                        Toolbar: CustomGridToolbar,
                                    }}
                                />
                            </Grid>
                        </>
                    </Grid>
                </div>
            </>
        </div>
    )
}

export default CompanyFormsPage